import React from "react"
import PropTypes from "prop-types"
import {Mutation as PerkboxMutation} from "@irati/utils/services/apollo"
import {injectIntl} from "@irati/utils/lang"

import handleNotifyError from "../helpers/handleNotifyError"

const Mutation = ({children, showNotifyOnError, formatMessage, onError, ...props}) => {
  const handleError = (error) => {
    if (showNotifyOnError) handleNotifyError(error, formatMessage)

    return onError && onError(error)
  }
  return (
    <PerkboxMutation onError={handleError} {...props}>
      {(mutation, apollo) => {
        return children(mutation, apollo)
      }}
    </PerkboxMutation>
  )
}

Mutation.propTypes = {
  children: PropTypes.func.isRequired,
  showNotifyOnError: PropTypes.bool,
  formatMessage: PropTypes.func.isRequired,
  onError: PropTypes.func
}

Mutation.defaultProps = {
  showNotifyOnError: true,
  onError: undefined
}

export default injectIntl(Mutation)
